import { render, staticRenderFns } from "./salesTrashed.vue?vue&type=template&id=30c73736&scoped=true"
import script from "./salesTrashed.vue?vue&type=script&lang=js"
export * from "./salesTrashed.vue?vue&type=script&lang=js"
import style0 from "./salesTrashed.vue?vue&type=style&index=0&id=30c73736&prod&lang=css"
import style1 from "./salesTrashed.vue?vue&type=style&index=1&id=30c73736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c73736",
  null
  
)

export default component.exports